import { render, staticRenderFns } from "./SuperAdminMenu.vue?vue&type=template&id=67a789fc"
import script from "./SuperAdminMenu.vue?vue&type=script&lang=js"
export * from "./SuperAdminMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports